/* ============================================================
   Boneca de Pano — sticky Add-to-Cart mobile da PDP.
   Barra fixa (acima do bottom-nav) com preço + botão verde que
   aciona o form principal do produto. Aparece via
   IntersectionObserver depois que o usuário rola além do buy box
   (fiel ao comportamento do site React).
   ============================================================ */
(function () {
  'use strict';

  // Rótulo da marca: o Dawn re-escreve o texto do botão de compra via
  // window.variantStrings na troca de variante — sobrescreve aqui para o
  // literal pt-BR da marca não voltar a "Adicionar ao carrinho".
  if (window.variantStrings && window.variantStrings.addToCart) {
    window.variantStrings.addToCart = 'Adicionar à Sacola';
  }

  if (customElements.get('bdp-sticky-atc')) return;

  var LABEL_ADD = 'Adicionar à Sacola';

  function formatBRLFromCents(cents) {
    try {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  class BdpStickyAtc extends HTMLElement {
    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.btn = this.querySelector('.bdp-sticky-atc__btn');
      this.amountEl = this.querySelector('.bdp-sticky-atc__amount');
      if (!this.productInfo || !this.btn) return;

      this.onClick = this.handleClick.bind(this);
      this.btn.addEventListener('click', this.onClick);

      var target =
        this.productInfo.querySelector('.product-form__buttons') ||
        this.productInfo.querySelector('.product-form__submit');
      if (target && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          function (entries) {
            var entry = entries[0];
            var pastBuyBox = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.classList.toggle('is-visible', pastBuyBox);
          }.bind(this),
          { threshold: 0.1 }
        );
        this.observer.observe(target);
      }

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
        this.unsubscribeVariant = subscribe(
          PUB_SUB_EVENTS.variantChange,
          function (event) {
            var data = (event && event.data) || {};
            if (data.sectionId !== this.productInfo.dataset.section) return;
            this.syncVariant(data.variant || null);
          }.bind(this)
        );
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (typeof this.unsubscribeVariant === 'function') this.unsubscribeVariant();
      if (this.btn) this.btn.removeEventListener('click', this.onClick);
    }

    syncVariant(variant) {
      if (!variant) {
        this.btn.disabled = true;
        this.btn.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Indisponível';
        return;
      }
      if (this.amountEl && typeof variant.price === 'number') {
        this.amountEl.textContent = formatBRLFromCents(variant.price);
      }
      this.btn.disabled = !variant.available;
      this.btn.textContent = variant.available
        ? LABEL_ADD
        : (window.variantStrings && window.variantStrings.soldOut) || 'Esgotado';
    }

    handleClick() {
      var submit = this.productInfo.querySelector('.product-form__submit');
      if (!submit) return;
      if (submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true') return;
      submit.click();
    }
  }

  customElements.define('bdp-sticky-atc', BdpStickyAtc);
})();
